import { FaCoins, FaTimes, FaLightbulb } from 'react-icons/fa';

// Offers a 50:50 hint two ways: watch a rewarded ad (free) or spend coins.
// The ad is user-initiated and clearly labelled.
export default function HintModal({ coins, cost, busy, onWatchAd, onUseCoins, onClose }) {
  const affordable = coins >= cost;

  return (
    <div className="fade-in fixed inset-0 z-[90] bg-slate-950/85 backdrop-blur-md flex items-center justify-center p-6">
      <div className="relative w-full max-w-sm rounded-[2rem] bg-slate-900 border border-white/10 p-7 text-center pop-in shadow-2xl">
        <button
          onClick={onClose}
          aria-label="Close"
          disabled={busy}
          className="absolute top-5 right-5 text-slate-400 hover:text-white disabled:opacity-40"
        >
          <FaTimes />
        </button>

        <div className="mx-auto mb-3 w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-600 flex items-center justify-center text-2xl text-white shadow-lg">
          <FaLightbulb />
        </div>
        <h2 className="text-xl font-black uppercase tracking-wide text-white">
          Need a <span className="text-gradient-brand">Hint?</span>
        </h2>
        <p className="mt-1 text-xs text-slate-400">
          We’ll remove one wrong answer for you.
        </p>

        <div className="mt-6 space-y-3">
          {/* Free via rewarded ad */}
          <button
            onClick={onWatchAd}
            disabled={busy}
            className="btn-3d relative w-full py-4 rounded-2xl bg-emerald-600 hover:bg-emerald-500 text-white font-black uppercase tracking-widest text-sm disabled:opacity-70"
          >
            <span className="absolute top-1.5 right-3 text-[8px] font-bold text-white/70">
              Watch Ad
            </span>
            {busy ? 'Loading…' : '🎬 Get Hint Free'}
          </button>

          {/* Pay with coins */}
          <button
            onClick={onUseCoins}
            disabled={busy || !affordable}
            className="btn-3d w-full py-4 rounded-2xl bg-violet-600 hover:bg-violet-500 text-white font-black uppercase tracking-widest text-sm disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <FaCoins className="text-amber-300" />
            {affordable ? `Use ${cost} Coins` : `Need ${cost} Coins`}
          </button>
        </div>
      </div>
    </div>
  );
}
